import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DropDown from './DropDown';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import IconBoxStyle11 from '../IconBox/IconBoxStyle11';
import Spacing from '../Spacing';
import { db } from '../../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';

export default function Header({ logoSrc, variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [sideNav, setSideNav] = useState(false);
  const [searchToggle, setSearchToggle] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;

    try {
      const blogRef = collection(db, 'blogs');
      const snapshot = await getDocs(blogRef);
      const matched = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((blog) => {
          const term = searchTerm.toLowerCase();
          return (
            blog.title?.toLowerCase().includes(term) ||
            blog.content?.toLowerCase().includes(term) ||
            blog.author?.toLowerCase().includes(term) ||
            blog.category?.toLowerCase().includes(term)
          );
        });
      setSearchResults(matched);
    } catch (error) {
      console.error('Error searching blogs:', error);
    }
  };

  return (
    <>
      <header
        className={`cs_site_header cs_style1 cs_sticky_header ${
          mobileToggle ? 'cs_mobile_toggle_active' : ''
        } ${variant} ${isSticky ? 'cs_active_sticky' : ''}`}
      >
        <div className='cs_main_header'>
          <div className='container'>
            <div className='cs_main_header_in'>
              <div className='cs_main_header_left'>
                <Link className='cs_site_branding' to='/'>
                  <img src={logoSrc} alt='Logo' />
                </Link>
                <nav className='cs_nav'>
                  <ul
                    className={`${
                      mobileToggle ? 'cs_nav_list cs_active' : 'cs_nav_list'
                    }`}
                  >
                    <li>
                      <Link to='/'>Home</Link>
                    </li>
                    <li>
                      <Link to='/about'>About</Link>
                    </li>
                    <li>
                      <Link to='/blog'>Blog</Link>
                    </li>
                    <li>
                      <Link to='/gallery'>Gallery</Link>
                    </li>
                    <li>
                      <Link to='/contact'>Contact</Link>
                    </li>
                  </ul>
                  <span
                    className={
                      mobileToggle
                        ? 'cs_menu_toggle cs_teggle_active'
                        : 'cs_menu_toggle'
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </nav>
              </div>
              <div className='cs_main_header_right'>
                <div className='cs_toolbox'>
                  <button
                    className='cs_toolbox_btn cs_search_toggle_btn'
                    type='button'
                    onClick={() => setSearchToggle(!searchToggle)}
                  >
                    <svg width={30} height={30} viewBox='0 0 30 30' fill='none'>
                      <path
                        d='M13.1684 0C5.91146 0 0 5.90944 0 13.164C0 20.4184 5.91146 26.3394 13.1684 26.3394C16.2681 26.3394 19.1188 25.2535 21.3719 23.4505L26.8571 28.931C27.1339 29.1962 27.5036 29.3426 27.887 29.3386C28.2704 29.3347 28.6371 29.1809 28.9084 28.91C29.1797 28.6392 29.3342 28.2729 29.3386 27.8896C29.3431 27.5064 29.1972 27.1365 28.9322 26.8595L23.4471 21.3762C25.2521 19.1204 26.3397 16.2662 26.3397 13.164C26.3397 5.90944 20.4254 0 13.1684 0ZM13.1684 2.926C18.8435 2.926 23.4099 7.49078 23.4099 13.164C23.4099 18.8371 18.8435 23.4134 13.1684 23.4134C7.4933 23.4134 2.92695 18.8371 2.92695 13.164C2.92695 7.49078 7.4933 2.926 13.1684 2.926Z'
                        fill='currentColor'
                      />
                    </svg>
                  </button>
                  <button
                    className='cs_toolbox_btn cs_sidebar_toggle_btn'
                    type='button'
                    onClick={() => setSideNav(!sideNav)}
                  >
                    {/* sidebar icon */}
                    <svg width={35} height={30} viewBox='0 0 35 30' fill='none'>
                      <path
                        d='M0.48 2.47C0.48 1.10 1.15 0 1.96 0H33.52C34.34 0 35 1.10 35 2.47C35 3.83 34.34 4.93 33.52 4.93H1.96C1.15 4.93 0.48 3.83 0.48 2.47Z'
                        fill='currentColor'
                      />
                      <path
                        d='M0.48 14.67C0.48 13.31 1.15 12.20 1.96 12.20H33.52C34.34 12.20 35 13.31 35 14.67C35 16.03 34.34 17.13 33.52 17.13H1.96C1.15 17.13 0.48 16.03 0.48 14.67Z'
                        fill='currentColor'
                      />
                      <path
                        d='M0.48 26.63C0.48 25.26 1.15 24.16 1.96 24.16H33.52C34.34 24.16 35 25.26 35 26.63C35 27.99 34.34 29.09 33.52 29.09H1.96C1.15 29.09 0.48 27.99 0.48 26.63Z'
                        fill='currentColor'
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Side Navigation */}
      <div className={`cs_sidenav ${sideNav ? 'active' : ''}`}>
        <div className='cs_sidenav_overlay' onClick={() => setSideNav(false)} />
        <div className='cs_sidenav_in'>
          <button className='cs_close' onClick={() => setSideNav(false)}>
            <img src='/images/icons/close.svg' alt='Close' />
          </button>
          <div className='cs_logo_box'>
            <img src='/images/logo2.png' alt='Logo' />
            <div className='cs_height_15' />
            <h3 className='cs_fs_24 cs_semibold mb-0'>
              Restoring Mobility. Rebuilding Confidence.
            </h3>
          </div>
          <Spacing md='35' />
          <hr />
          <Spacing md='35' />
          <IconBoxStyle11
            title='Phone'
            subTitle='OFFICE (225) 665-0323'
            iconSrc='/images/contact/icon_1.svg'
          />
          <Spacing md='30' />
          <IconBoxStyle11
            title='Email'
            subTitle='Ricky@freedomprola.com'
            iconSrc='/images/contact/icon_2.svg'
          />
          <Spacing md='30' />
          <IconBoxStyle11
            title='Location'
            subTitle='9354 Florida Blvd, Denham Springs, LA'
            iconSrc='/images/contact/icon_3.svg'
          />
          <Spacing md='60' />
          <SocialWidget />
        </div>
      </div>

      {/* Search Box */}
      <div className={`cs_header_search ${searchToggle ? 'active' : ''}`}>
        <div className='cs_header_search_in'>
          <div className='container'>
            <div className='cs_header_search_box'>
              <form className='cs_search_form' onSubmit={handleSearch}>
                <input
                  type='text'
                  placeholder='Search Articles'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button className='cs_search_btn' type='submit'>
                  🔍
                </button>
              </form>
              <button
                className='cs_close'
                onClick={() => setSearchToggle(false)}
              >
                <img src='/images/icons/close.svg' alt='Close' />
              </button>
            </div>

            {/* Optional: Display search results here */}
            {searchResults.length > 0 && (
              <div className='cs_search_results mt-6 space-y-4'>
                {searchResults.map((blog) => (
                  <Link
                    to={`/blog/${blog.id}`}
                    key={blog.id}
                    className='block p-4 border rounded hover:shadow-md transition bg-white'
                  >
                    <h4 className='text-lg font-semibold text-primary'>
                      Title: {blog.title}
                    </h4>
                    <p className='text-sm text-gray-700 mt-1'>
                      Author: {blog.author || 'Staff Writer'}
                    </p>
                    <p className='text-sm text-gray-600'>
                      Category: {blog.category || 'Uncategorized'}
                    </p>
                    <p className='text-sm text-gray-500 mt-2 line-clamp-3'>
                      Content: {blog.content?.slice(0, 120)}...
                    </p>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
        <div
          className='cs_sidenav_overlay'
          onClick={() => setSearchToggle(false)}
        />
      </div>
    </>
  );
}
